import { SnackbarOrigin } from '@mui/material/Snackbar';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SnackbarState {
  open: boolean;
  message: string;
  variant: 'success' | 'warning' | 'error' | 'info';
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
  action?: React.ReactNode;
}

const initialState: SnackbarState = {
  open: false,
  message: '',
  variant: 'info',
  autoHideDuration: 5000,
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<Omit<SnackbarState, 'open'>>) => {
      return {
        ...state,
        ...action.payload,
        open: true,
      };
    },
    hideSnackbar: state => {
      state.open = false;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
